import React from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import { buildApiUrl } from "../../config/environment";

import {
  CorporateInformation,
  DataProtectionPolicy,
  FileViewer,
  CopyrightInformation,
} from "../index";

import * as axios from "axios";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  dialogPaper: {
    minHeight: "72vh",
    maxHeight: "80vh",
    overflowX: "hidden",
    borderRadius: "12px",
    maxWidth: "55%",
  },
  tabsBar: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: "none",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabsRoot: {
    minHeight: "48px",
  },
  tabRoot: {
    minHeight: "48px",
    textTransform: "none",
    fontSize: "0.875rem",
    fontWeight: 500,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.75rem",
      minWidth: "auto",
    },
  },
  tabPanel: {
    overflowY: "auto",
    maxHeight: "calc(80vh - 120px)",
    padding: "24px",
    [theme.breakpoints.down("xs")]: {
      padding: "16px",
    },
  },
}));

const FooterTabs = ({ clickValue, open, onClose }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [policyData, setPolicyData] = React.useState("");
  const [termCondData, setTermCondData] = React.useState("");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };
  //   const prevProps = useRef({ clickValue, open, handleClose });
  React.useEffect(() => {
    // if (prevProps.clickValue !== props.clickValue
    if (policyData === "") {
      axios({
        url: buildApiUrl("/user/consent/privacypolicy"),
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          if (response.data) {
            const file = new File([response.data], "untitled", {
              type: "application/pdf",
            });

            setPolicyData(file);
          } else {
            return false;
          }
        })
        .catch(function (err) {
          //for any CORS/Error cases
          return false;
        });
    }
    if (!termCondData) {
      axios({
        url: buildApiUrl("/user/consent/tnc"),
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          if (response.data) {
            const file = new File([response.data], "untitled", {
              type: "application/pdf",
            });

            setTermCondData(file);
          } else {
            return false;
          }
        })
        .catch(function (err) {
          //for any CORS/Error cases
          return false;
        });
    }
    {
      setValue(clickValue);
    }
  }, [clickValue]);

  return (
    <div className={classes.root}>
      <Dialog
        classes={{ paper: classes.dialogPaper }}
        maxWidth={"md"}
        open={open}
        onClose={() => {
          onClose();
        }}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <AppBar position="static" color="default" className={classes.tabsBar}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="footer docs"
            classes={{ root: classes.tabsRoot }}
          >
            <Tab
              label="Corporate Information"
              {...a11yProps(0)}
              classes={{ root: classes.tabRoot }}
            />
            <Tab
              label="Privacy Policy"
              {...a11yProps(1)}
              classes={{ root: classes.tabRoot }}
            />
            <Tab
              label="Legal Policy"
              {...a11yProps(2)}
              classes={{ root: classes.tabRoot }}
            />
            <Tab
              label="Terms and Conditions"
              {...a11yProps(3)}
              classes={{ root: classes.tabRoot }}
            />
            <Tab
              label="Copyright"
              {...a11yProps(4)}
              classes={{ root: classes.tabRoot }}
            />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          style={{ overflow: "inherit" }}
          onChangeIndex={handleChangeIndex}
        >
          <TabPanel value={value} index={0} dir={theme.direction} className={classes.tabPanel}>
            <CorporateInformation />
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction} className={classes.tabPanel}>
            {/* <FileViewer pdfFile={PrivacyPolicy} /> */}
            <FileViewer pdfFile={policyData} docType="policyData" />
            {/* <LegalNotice /> */}
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction} className={classes.tabPanel}>
            <DataProtectionPolicy />
          </TabPanel>
          <TabPanel value={value} index={3} dir={theme.direction} className={classes.tabPanel}>
            <FileViewer pdfFile={termCondData} docType="termCondData" />
          </TabPanel>
          <TabPanel value={value} index={4} dir={theme.direction} className={classes.tabPanel}>
            <CopyrightInformation />
          </TabPanel>
        </SwipeableViews>
      </Dialog>
    </div>
  );
};

export default React.memo(FooterTabs);
